module.exports = __webpack_public_path__ + "static/media/huilianyoushi.93529790.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/detail/images/huilianyoushi.png
// module id = 747
// module chunks = 0